import React, { useEffect, Fragment, useState, useRef } from 'react'
import { Button, Modal, Card, Row, Col, Form, OverlayTrigger, Tooltip, Table } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes';
import { serviceGetProcesosJudiciales } from '../../../api/api-consulta-hitos';
import Seguimiento from './seguimiento';


const Procesos = ({ showModal, setShowModal, idCaso, idOrgCaso, tipoGestion }) => {
    const [loading, setLoading] = useState(false);
    const [procesos, setProcesos] = useState([]);
    const [showSeguimiento, setShowSeguimiento] = useState(false);
    const [procesoSeguimiento, setProcesoSeguimiento] = useState(null);

    useEffect(() => {
        if (showModal) getProcesosJudiciales();
    }, [showModal])

    const getProcesosJudiciales = async () => {
        setLoading(true);
        let query = Buffer.from(JSON.stringify({ idCaso: idCaso })).toString('base64');
        const response = await serviceGetProcesosJudiciales(query);

        setLoading(false);
        setProcesos(response);
    }

    const handleSegimiento = (selected, pos) => {
        setShowSeguimiento(true);
        setProcesoSeguimiento(selected);
    }

    const handleClose = () => {
        setShowModal(false);
        setShowSeguimiento(false);
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Card>
                <Card.Header className='cardHeader'>
                    SEGUIMIENTO PROCESOS JUDICIALES
                </Card.Header>
                <Card.Body>
                    <Card>
                        <Table striped className="customTable">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Competencia</th>
                                    <th>Region/Corte</th>
                                    <th>Juzgado/Tribunal</th>
                                    <th>Nro. Causa/Rol</th>
                                    <th>Fecha Ing. Causa</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {procesos.map((proceso, index) => (
                                    <tr key={index}>
                                        <td >
                                            <Form.Check type="radio" name="group1" id={`radio-${index}`} onChange={() => handleSegimiento(proceso, index)} />
                                        </td>
                                        <td>{proceso.competencia}</td>
                                        <td>{proceso.corte}</td>
                                        <td>{proceso.tribunal}</td>
                                        <td>{proceso.rolCausa}</td>
                                        <td>{proceso.fecIngresaCausaFormat}</td>
                                        <td>{proceso.glosaEstado}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        {procesos.length === 0 &&
                            <div><span style={{ display: 'inherit', textAlign: 'center', marginBottom: '20px' }}>No hay registros encontrados.</span></div>
                        }

                        <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                            <Button className='w-auto' variant='outline-info' onClick={handleClose}>
                                Volver
                            </Button>
                        </Card.Footer>
                    </Card>

                    {showSeguimiento && <Seguimiento
                        idCaso={idCaso}
                        idOrgCaso={idOrgCaso}
                        tipoGestion={tipoGestion}
                        proceso={procesoSeguimiento}
                    />}
                </Card.Body>
            </Card>
        </Fragment>
    )
}

export default Procesos